<router-outlet [dir]="layoutService.websiteDirection$.value"></router-outlet>
<app-loading></app-loading>
<simple-notifications></simple-notifications>